import { createContext, useContext, useState, useEffect } from "react";

type OrgContextType = {
  orgId: number | null;
  locationId: string | null;
};

const OrgContext = createContext<OrgContextType | null>(null);

export const OrgProvider = ({ children }: { children: React.ReactNode }) => {
  const [orgId, setOrgId] = useState<number | null>(null);
  const [locationId, setLocationId] = useState<string | null>(null);
  const isIframe = window !== window.parent;

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      console.log('Received message:', event.data, 'by', window.origin, '. Received from:', event.origin);

      if (event.data.message === 'update') {
        const { params } = event.data;

        if (params) {
          setOrgId(params.organization_id || 9);
          setLocationId(params.location_id || null);
        }
      }
    };

    if (isIframe) {
      window.addEventListener("message", handleMessage);
    } else {
      setOrgId(54);
      setLocationId('national');
    }

    return () => {
      if (isIframe) window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <OrgContext.Provider value={{ orgId, locationId }}>
      {children}
    </OrgContext.Provider>
  );
};

export const useOrgContext = () => {
  const context = useContext(OrgContext);
  if (!context) {
    throw new Error("useOrgContext must be used within an OrgProvider");
  }
  return context;
};